import GraphicFiltersForm from "./graphic-filters-form";

export default GraphicFiltersForm;